import type { TFetchError } from '../api-error.types';
import { CONTACT_IMPORT_JOB_NOT_FOUND_CODE } from '../error-codes';

export const isImportSessionNotFound = (error: unknown): boolean => {
  const fetchError = error as TFetchError | null;
  return (
    fetchError?.data?.code === CONTACT_IMPORT_JOB_NOT_FOUND_CODE ||
    fetchError?.status === 404 ||
    fetchError?.data?.statusCode === 404
  );
};
